import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { ImportUrlRequestType } from '@app-store/slices/dataImport/getPreSignedImportURL'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface TaskAction extends Action {
    payload: ImportUrlRequestType
}

const { onRequest, onSuccess, onFailure } = rootActions.dataImport.getPreSignedImportUrl

function* getPreSignedImportURLSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/companies/imports/imported-excel/${payload.id}`)
        if (response.success) {
            if (payload.downloadQuick) {
                const link = document.createElement('a')
                link.setAttribute('download', response.result.file)
                link.href = response.result.downloadURL
                document.body.appendChild(link)
                link.click()
            }
            yield put(onSuccess(response.result))
        } else {
            throw 'Some thing wrong.'
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* getPreSignedImportURLSaga(): any {
    yield takeLatest<TaskAction>(onRequest, getPreSignedImportURLSagaTask)
}

export default getPreSignedImportURLSaga
